// import { captureException } from '@sentry/react';

export const mobxCaptureExeptionMiddleware = (call, next) => {
  try {
    next(call);
  } catch (error) {
    console.group("Mobx error");
    console.log(`Action name %c${call.name}`, "color: yellow");
    console.log(error);
    console.log("New value", call.args[0]);
    console.groupEnd();
    // captureException(error);
  }
};
